var map = {
	"./School/router.config.js": "a4d5",
	"./aice/router.config.js": "4087",
	"./aipj/router.config.js": "4fe9",
	"./default/router.config.js": "3621",
	"./kexie/router.config.js": "755f",
	"./mooccode/router.config.js": "25af",
	"./wayi/router.config.js": "57fa",
	"./wuge/router.config.js": "fba3",
	"./xmw/router.config.js": "ef4e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "88f3";